/**
 * パンくずリストコンポーネント
 */

import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Breadcrumb.css";

/**
 * パンくずリスト
 * @returns {JSX.Element} パンくずリストのJSX要素
 */
export function Breadcrumb(): JSX.Element {
  const { t } = useTranslation();
  /**
   * パス名と日本語ラベルのマッピング
   */
  const pathNameMap: { [key: string]: string } = {
    anasys: t("アナシストップ"),
    AnasysJis2004: "環境依存文字使用時の動作について",
    "cmcd-200": "CMCD-200トップ",
    "gas-log-reader": "GasLogReaderトップ",
    HowToDownload: t("ダウンロード方法"),
    HowToDownloadAndInstall: t("ダウンロードとインストールの手順"),
    HowToDownloadDeviceDriver: t("デバイスドライバーのダウンロード方法"),
    HowToInstallDeviceDriver: t("デバイスドライバーのインストール方法"),
    HowToUninstallDeviceDriver: t("デバイスドライバーのアンインストール方法"),
    HelpAndSupport: t("トラブルシューティング"),
    Download: t("ダウンロード"),
    NetFrameworkCheck: t(".NET Frameworkインストール済みバージョンの確認方法"),
    Windows11Supported: t("Windows 11対応のお知らせ"),
    WindowsSupportEnd: t("Windowsの動作保証終了OSについて"),
    HowToUse: t("使い方"),
    Ghs8atCoverSetting: t("外ケース取り付け時の注意点"),
    Ghs8atMeasureConditions: t("GHS-8AT測定値の扱いと各ロギング条件の動作説明"),
    Terms: t("利用規約"),
    PrivacyPolicy: t("プライバシーポリシー"),
    Version: t("バージョン情報"),
  };

  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <ul
      itemScope
      itemType="http://data-vocabulary.org/Breadcrumb"
      className="breadcrumb"
    >
      {pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === pathnames.length - 1;
        const label = pathNameMap[value] || value; // 日本語ラベルを取得
        return isLast ? (
          <li key={to} aria-current="page">
            {label}
          </li>
        ) : (
          <li key={to}>
            <Link to={to}>{label}</Link>
          </li>
        );
      })}
    </ul>
  );
}
